import clsx from 'clsx';
import React from 'react';
import { Header, HeaderSubheader, Modal } from 'semantic-ui-react';
import CustomModal from '../CustomModal';
import POSButton from '../POSButton';
import './ConfirmModal.less';

export interface ConfirmModalProps {
  openConfirmModal: boolean;
  headerContent: string;
  subHeaderContent: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  setOpenConfirmModal: (openConfirmModal: boolean) => void;
  onConfirm: () => void;
  className?: string;
  children?: React.ReactNode;
  icon?: 'question' | 'exclamation';
}

export const ConfirmModal = ({
  openConfirmModal,
  headerContent,
  subHeaderContent,
  primaryButtonText,
  secondaryButtonText,
  setOpenConfirmModal,
  onConfirm,
  className,
  children,
  icon = 'exclamation',
}: ConfirmModalProps) => {
  return (
    <CustomModal
      open={openConfirmModal}
      className={clsx('confirm-modal-popup', className)}
      size={'small'}
      centered
    >
      <CustomModal.Content>
        <Modal.Description>
          <span className={clsx('mark', icon)} />
          <Header className="confirm-modal-content-info">
            {headerContent}
          </Header>
          <HeaderSubheader className="confirm-modal-sub-header-info">
            {subHeaderContent}
          </HeaderSubheader>
          {children}
        </Modal.Description>
      </CustomModal.Content>
      <CustomModal.Actions>
        <POSButton
          inverted
          onClick={() => setOpenConfirmModal(!openConfirmModal)}
        >
          {secondaryButtonText}
        </POSButton>
        <POSButton onClick={onConfirm}>{primaryButtonText}</POSButton>
      </CustomModal.Actions>
    </CustomModal>
  );
};
